<template>
  <button
    class="nav-sections__button"
    :class="{ _active: isActive }"
    :title="title"
    @click="onMenuButtonClick()"
  >
    <svg class="icon--filter" width="32" height="32">
      <use v-bind:xlink:href="`#${buttonType}`" />
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    buttonType: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: () => ''
    },
    isActive: {
      type: Boolean,
      default: () => false
    }
  },

  methods: {
    onMenuButtonClick() {
      this.$emit('setNewStatus');
    }
  }
};
</script>
